import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class AwsService {
  async getData(data) {
    return (await fetchApi.post(`/aws`, data)).data;
  }

  async delete(data) {
    return (await fetchApi.post(`/aws/delete`, data)).data;
  }

  async getDownloadUrl(Workspace_id, data, files) {
    return (await fetchApi.post(`/aws/${Workspace_id}/download?` + new URLSearchParams(data).toString(), files)).data;
  }

  async getUploadUrl(data) {
    return (await fetchApi.post(`/aws/getUploadURL`, data)).data;
  }

  async completeMultipartUpload(data) {
    return (await fetchApi.post(`/aws/completeMultipartUpload`, data)).data;
  }

  async abortMultipartUpload(data) {
    return (await fetchApi.post(`/aws/abortMultipartUpload`, data)).data;
  }

  async uploadObject(formData, ProcessQueue_id, customHeaders) {
    return (await fetchApi.postFormData(`/aws/upload?ProcessQueue_id=${ProcessQueue_id}`, formData, customHeaders))
      .data;
  }

  async manageObject(data) {
    return (await fetchApi.post(`/aws/manage-object`, data)).data;
  }
}
